import React from "react";
import {connect} from "react-redux";
import {Button, Form, Input, Modal, Select, Space, message} from "antd";
import {displayErrors} from "../../libs/utils";
import {loadAllCompanies} from "../../actions/users";
import {adminCreateIPAddressReservation} from "../../actions/ip_addresses";

class NewIPAddressReservationListModal extends React.Component {
    state = {
        loadingCompanies: false,
        companiesLoaded: false,
        companies: [],
        name: '',
        selectedCompany: '',
        saving: false,
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.showModal && !this.state.loadingCompanies && !this.state.companiesLoaded) {
            this.adminLoadCompanies();
        }
    }

    closeModal(reload = false) {
        this.setState({
            loadingCompanies: false,
            companiesLoaded: false,
            companies: [],
            name: '',
            selectedCompany: '',
            saving: false,
        });

        this.props.close();

        if(reload) {
            this.props.reload();
        }
    }

    adminLoadCompanies() {
        this.setState({ loadingCompanies: true, companiesLoaded: false });

        this.props.loadAllCompanies((res) => {
            this.setState({ loadingCompanies: false, companiesLoaded: true, companies: res.data.data });
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                this.setState({ loadingCompanies: false, companiesLoaded: true });
                displayErrors(err.response.data);
            }
        });
    }

    saveList() {
        let name = this.state.name.trim();
        let list_owner = this.state.selectedCompany;

        if(name.length === 0) {
            return message.error('Please enter list name!');
        }

        if(list_owner.length === 0) {
            return message.error('Please select the list owner!');
        }

        let data = { name, list_owner };

        this.setState({ saving: true });

        this.props.adminCreateIPAddressReservation(data, () => {
            this.setState({ saving: false });
            message.success('List successfully created!');
            this.closeModal(true);
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                this.setState({ saving: false });
                displayErrors(err.response.data);
            }
        });
    }

    render() {
        const { Option } = Select;

        return(
            <Modal title='Reservation List'
                   open={this.props.showModal}
                   onCancel={() => this.closeModal()}
                   footer={<Space>
                       <Button disabled={this.state.saving} onClick={() => this.closeModal()}>Close</Button>
                       <Button disabled={this.state.saving} loading={this.state.saving}  type='primary' onClick={() => this.saveList()}>Save</Button>
                   </Space>}>
                <Form layout='vertical'>
                    <Form.Item label='Name'>
                        <Input value={this.state.name} onChange={(e) => this.setState({ name: e.target.value })} />
                    </Form.Item>
                    <Form.Item label='Owner'>
                        <Select
                            filterOption={(input, option) => {
                                if(typeof option !== 'undefined') {
                                    return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                }
                                return false;
                            }}
                            loading={this.state.loadingCompanies}
                            disabled={this.state.loadingCompanies}
                            value={this.state.selectedCompany}
                            showSearch
                            allowClear
                            onChange={(value) => this.setState({ selectedCompany: value })}>
                            {this.state.companies.map((company, i) => {
                                return <Option key={i} value={company.guid}>{company.name}</Option>
                            })}
                        </Select>
                    </Form.Item>
                </Form>
            </Modal>
        )
    }
}

export default connect(null, { loadAllCompanies, adminCreateIPAddressReservation })(NewIPAddressReservationListModal);